import React from 'react';
import { TableInstance } from 'react-table';

import { IEntityTable } from '../entity-table/EntityTable';

import { ProjectControllingTable } from './ProjectControllingTable';

export const REMOVED_COLS_IDS = ['projectControllingComparison'];
export const DEFAULT_COLS_IDS = [
  'name',
  'projectStatus.id',
  'projectTimeTracking',
  'projectControllingActual',
  'projectControllingTargetContributionMargin',
];

export const ContributionMarginTable = React.forwardRef<
  TableInstance,
  IEntityTable
>(function ContributionMarginTable(props, ref) {
  return (
    <ProjectControllingTable
      {...props}
      ref={ref}
      removedColIds={REMOVED_COLS_IDS}
      defaultColIds={DEFAULT_COLS_IDS}
    />
  );
});
